import { render, staticRenderFns } from "./ViolationsTable.vue?vue&type=template&id=60762b01&"
import script from "./ViolationsTable.vue?vue&type=script&lang=js&"
export * from "./ViolationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports